import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Webshops } from '../../../store/models/webshops';
import { LoginsService } from '../shared/logins.service';

@Component({
    selector: 'kkis-app-webshop-login1',
    templateUrl: './login1.component.html',
    styleUrls: ['./login1.component.scss']
})

export class Login1Component implements OnInit {

    // if 'enter'-key is pressed => call onLogin()
    @HostListener('window:keyup.enter', ['$event']) 
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.key == 'Enter') {
            this.onLogin();
        }
    }

    // formgroup
    form: FormGroup;

    // Login-Data
    userLogin = {} as Webshops.IUserLogin;
    loggedInUser: Webshops.ILoggedInUser;

    
    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<Login1Component>,
        private loginsService: LoginsService,
    ) { }

    ngOnInit(): void {
        this.form = this.fb.group({
            userName: ['', Validators.required],
            userPwd: ['', Validators.required],
        });

        this.dialogRef.keydownEvents().subscribe(event => {
            if (event.key === 'Escape') {
                this.onCancel();
            }
        });
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.form.controls[controlName].hasError(errorName);
    }

    onLogin() {

        if (this.form.invalid) return;
    
        this.userLogin.userName = this.form.get('userName').value;
        this.userLogin.userPassword = this.form.get('userPwd').value;

        this.loginsService.getLoggedInUser(this.userLogin.userName, this.userLogin.userPassword).subscribe(res => {
            this.loggedInUser = res;

            this.dialogRef.close(this.loggedInUser);
        });
    }

    onCancel() {
        this.dialogRef.close(null);
    }
}
